// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"204":"1a2acf9db67e88c2","303":"2437ffe5d293e5c2","913":"f7499a02d433a138","996":"3755663f413994eb"}[chunkId] + ".js";
};